import { render, staticRenderFns } from "./WorkBookInput.vue?vue&type=template&id=35cdca21&scoped=true&"
import script from "./WorkBookInput.vue?vue&type=script&lang=js&"
export * from "./WorkBookInput.vue?vue&type=script&lang=js&"
import style0 from "./WorkBookInput.vue?vue&type=style&index=0&id=35cdca21&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35cdca21",
  null
  
)

export default component.exports